import Container from 'typedi';
import DocumentRepository from '../repositories/DocumentRepository';
import ItemService from './ItemService';

class DocumentService {
  documentRepository;
  itemService;
  constructor() {
    this.documentRepository = Container.get(DocumentRepository);
    this.itemService = Container.get(ItemService);
  }
  getTypes = () => this.documentRepository.getTypes();
  getType = (id) => this.documentRepository.getType(id);
  getDocuments = async (page, rowsPerPage) => await this.documentRepository.getDocuments(page, rowsPerPage);
  getDocumentsByIdOperation = async (idOperation) => await this.documentRepository.getDocumentsByIdOperation(idOperation);
  getDocumentsByIdActivity = async (idActivity) => await this.documentRepository.getDocumentsByIdActivity(idActivity);
  processMassiveDocumentSubmission(documents, itemTypes) {
    const requestDocuments = [];
    if (documents.length) {
      documents.forEach((document) => {
        const requestItems = document.items
          ? this.itemService.processMassiveItemSubmission(document.items, itemTypes)
          : [];
        const documentBody = {
          number: document.documentNumber,
          status: 1,
          type: 1,
          items: requestItems,
        };
        requestDocuments.push(documentBody);
      });
    }
    return requestDocuments;
  }
}

Container.set({ id: DocumentService, type: DocumentService });

export default DocumentService;
